export const projectHeaderTab = {
  upload: "upload-data",
  scenarios: "define-scenarios",
  simulations: "manage-simulations",
};

export const projectHeaderTabs = [
  { value: projectHeaderTab.upload, label: "Manage Data" },
  {
    value: projectHeaderTab.scenarios,
    label: "Define Scenario",
    validation: true,
  },
  {
    value: projectHeaderTab.simulations,
    label: "Manage Simulation",
    validation: true,
  },
];

export const getTabRoute = (tab, id) => {
  const item = projectHeaderTabs.find((it) => it.value === tab);
  const extraProp = tab === projectHeaderTab.upload ? "/scenarios" : "";
  const route = `/project/${item.value}/${id}${extraProp}`;
  return route;
};
